var invoiceSwitcher =
  {
    switcherSelector: '#billing_invoice',
    switcherContainerSelector: '#billing_invoice_field',
    fieldsIdPrefix: 'billing_invoice_',

    init: function () {
      var _self = this;

      $(this.switcherSelector).prop('checked', false).change(function () {
        _self.switchFields();
      });

      this.switchFields();
    },

    switchFields: function () {
      var $fields = $(this.switcherContainerSelector).nextAll('[id^=' + this.fieldsIdPrefix + ']');

      if ($(this.switcherSelector).prop('checked')) {
        $fields.show();
        $fields.each((index, item) => {
          $(item).find('input').val('')
        })
        $fields.removeClass('woocommerce-validated')
      } else {
        $fields.hide();
        $fields.each((index, item) => {
          $(item).find('input').val('.')
        })
      }
    }
  };
invoiceSwitcher.init()
